import { useMemo } from 'react'

import { isNull } from 'lodash'

const dateRegex = /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})/

/**
 * @param str
 * @returns {array} ex: (4) ['02:02 am', '02', '02', 'am', index: 0, input: '02:02 am', groups: undefined]

 */
const timeRegex = /([0-9]{1,2}):?([0-9]{1,2})\s?([ap]m?)/i

export const getDateObjFromDateString = (str: string) => {
  const matches = dateRegex.exec(str)
  if (!matches) return
  const month = parseInt(matches[1])
  const day = parseInt(matches[2])
  const year = parseInt(matches[3])
  const date = new Date()
  date.setMonth(month - 1)
  date.setDate(day)
  date.setFullYear(year)
  return date
}

export const isValidDate = (date: Date | null) => {
  return !isNull(date) && date.toString() !== 'Invalid Date'
}

const getMatches = (str: string) => {
  const matches = timeRegex.exec(str)
  if (!matches) return null
  return matches
}
const getHours = (hoursStr: string, ampmStr: string) => {
  let hours = parseInt(hoursStr)
  if (ampmStr.toLowerCase() === 'pm') {
    hours += 12
  }
  return hours
}

export const getDateObjFromTimeString = (str: string) => {
  const matches = getMatches(str)
  if (!matches) return
  const [, hoursStr, minutesStr, ampmStr] = matches
  const hours = getHours(hoursStr, ampmStr)
  const minutes = parseInt(minutesStr)
  const date = new Date()
  date.setHours(hours)
  date.setMinutes(minutes)
  return date
}

export const useDate = (item: any, field: string) => {
  return useMemo(() => {
    const val = item[field]
    if (!val) return null
    const d = new Date(val)
    if (!isValidDate(d)) return null
    return d
  }, [item, field])
}

export const getZoneAbbrev = (date: Date = new Date()) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const parts = Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  }).formatToParts(date)

  return parts.find((part) => part.type === 'timeZoneName')?.value ?? ''
}
